import React, { useEffect, useState, useRef } from 'react'
import { FaArrowAltCircleRight } from 'react-icons/fa'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { useSearchParams, useNavigate } from 'react-router-dom'
import styles from './Search.module.css'
import {
  useGetSparesByDescriptionMutation,
  useSearchSparesBrandMutation,
} from '../../../redux/searchSpares/apiSearchSpares'
import { toast } from 'react-toastify'
import Loader from '../../loader/Loader'
import SearchBrand from './searchBrand/SearchBrand'
import filterString from '../../../utils/filterString'
import { useDispatch, useSelector } from 'react-redux'
import {
  setSearchedSpare,
  selectPendingNoteSearch,
  clearPendingNoteSearch,
} from '../../../redux/searchSpares/sparesSlice'
import { useGetClientSearchHistoryQuery } from '../../../redux/clientData/apiClientData'
import banner from '../../../img/banner.png'
import banner2 from '../../../img/banner2.png'
import fastSearchData from '../../../data/fastSearchData'
import GroupSelector from './searchFinal/GroupSelector'
import QuickCatalog from './quickCatalog/QuickCatalog'

const Search = () => {
  const [searchInput, setSearchInput] = useState('')
  const [searchBrand, setSearchBrand] = useState(null)
  const [isInputHovered, setIsInputHovered] = useState(false)
  const [isSearchByDesc, setIsSearchByDesc] = useState(false)
  const [isFastSearch, setIsFastSearch] = useState(false)
  const [isQuickSearchUsed, setIsQuickSearchUsed] = useState(false)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [searchSparesBrand, { isLoading: isLoadingSearchSparesBrand }] =
    useSearchSparesBrandMutation()

  const [
    getSparesByDescription,
    { isLoading: isLoadingSearchSparesByDescription },
  ] = useGetSparesByDescriptionMutation()

  const {
    data: searchHistory,
    isLoading: isLoadingSearchHistory,
    refetch,
  } = useGetClientSearchHistoryQuery()

  const dispatch = useDispatch()
  const pendingNoteSearch = useSelector(selectPendingNoteSearch)
  const fastSearchRef = useRef(null)

  useEffect(() => {
    if (isInputHovered) {
      refetch()
    }
  }, [refetch, isInputHovered])

  
  useEffect(() => {
    const codeFromUrl = searchParams.get('code')
    if (codeFromUrl) {
      setSearchInput(codeFromUrl)
      handleSearchSparesByBrand(codeFromUrl)
      navigate('/shop', { replace: true })
    }
  }, [searchParams, navigate])

  useEffect(() => {
    if (pendingNoteSearch?.code) {
      setSearchInput(pendingNoteSearch.code)
      handleSearchSparesByBrand(
        pendingNoteSearch.code,
        undefined,
        pendingNoteSearch.brand
      )
      dispatch(clearPendingNoteSearch())
    }
  }, [pendingNoteSearch, dispatch])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isFastSearch &&
        fastSearchRef.current &&
        !fastSearchRef.current.contains(event.target)
      ) {
        setIsFastSearch(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isFastSearch])

  const handleSearchSparesByBrand = async (
    searchValue = searchInput,
    groupName,
    targetBrand
  ) => {
    setSearchBrand(null)
    try {
      if (isSearchByDesc) {
        handleSearchByDesc()
        return
      }
      const code = filterString(searchValue)
      if (!code) {
        toast.error('Введіть код для пошуку')
        return
      }
      dispatch(setSearchedSpare(code))
      const response = await searchSparesBrand({ code })
      if (response.data) {
        setSearchBrand({
          ...response.data,
          selectedGroup: groupName,
          selectedBrand: targetBrand,
        })
      }
    } catch (error) {
      toast.error('Сталась помилка...')
    }
  }

  const handleSearchByDesc = async () => {
    try {
      const spares = await getSparesByDescription({
        desc: searchInput,
      }).unwrap()
      setSearchBrand(spares)
    } catch (error) {
      toast.error('Сталась помилка...')
    }
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSearchSparesByBrand()
    }
  }

  const removeDuplicates = (searchHistory) => {
    const uniqueSet = new Set()
    const uniqueArray = searchHistory.filter((item) => {
      const key = `${item?.brand?.trim()}${item?.code?.trim()}`
      if (uniqueSet.has(key)) {
        return false
      }
      uniqueSet.add(key)
      return true
    })
    return uniqueArray
  }

  const handleQuickSearch = (value, groupName) => {
    setIsQuickSearchUsed(true)
    setSearchInput(value)
    setIsFastSearch(false)
    handleSearchSparesByBrand(value, groupName)
  }

  const carouselSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
  }

  return (
    <div className={styles.searchMain}>
      {isLoadingSearchSparesBrand && <Loader />}
      {isLoadingSearchHistory && <Loader />}
      {isLoadingSearchSparesByDescription && <Loader />}
      <div className={styles.searchContainer}>
        <div className={styles.searchTop}>
          <div
            className={styles.fastSearchWrapper}
            ref={fastSearchRef}
            onMouseEnter={() => setIsFastSearch(true)}
            onMouseLeave={() => setIsFastSearch(false)}
          >
            <button
              className={styles.fastSearchBtn}
              onClick={() => setSearchBrand(null)}
            >
              Групи товарів
            </button>
            {isFastSearch && (
              <div className={styles.fastSearchOverlay}>
                <GroupSelector
                  groups={fastSearchData}
                  onSelect={handleQuickSearch}
                />
              </div>
            )}
          </div>
          <div className={styles.searchText}>Пошук:</div>
          <div
            onMouseEnter={() => setIsInputHovered(true)}
            onMouseLeave={() => setIsInputHovered(false)}
            className={styles.searchInputContainer}
          >
            <input
              className={styles.searchInput}
              type="text"
              onChange={(e) => setSearchInput(e.target.value)}
              value={searchInput}
              onKeyDown={handleKeyDown}
            />
            {isInputHovered &&
              searchHistory?.clientSearchHistory?.length > 0 && (
                <div className={styles.searchHistoryContainer}>
                  {removeDuplicates(searchHistory?.clientSearchHistory)?.map(
                    (search, i) =>
                      i < 5 &&
                      search.brand &&
                      search.code && (
                        <div
                          key={i}
                          onClick={() => setSearchInput(search.code)}
                          className={styles.searchHistoryItem}
                        >
                          <span>{search.brand}</span>
                          <span>{search.code}</span>
                        </div>
                      )
                  )}
                </div>
              )}
          </div>
          <div className={styles.searchBtnContainer}>
            <button
              onClick={() => handleSearchSparesByBrand()}
              className={styles.searchBtn}
            >
              <FaArrowAltCircleRight />
            </button>
          </div>
          <>
            <span className={styles.descriptionSearchContainer}>
              Пошук по опису
            </span>
            <input
              type="checkbox"
              className={styles.checkbox}
              checked={isSearchByDesc}
              onChange={() => setIsSearchByDesc(!isSearchByDesc)}
            />
          </>
          <div className={styles.carouselBlock}>
            <div className={styles.carouselContainer}>
              <Slider {...carouselSettings}>
                <div>
                  <img src={banner} alt="1" />
                </div>
                <div>
                  <img src={banner2} alt="2" />
                </div>
              </Slider>
            </div>
          </div>
        </div>
        <div className={styles.warningText}>
          Перевіряйте правильність аналогів та характиристики товарів за
          надійними джерелами!
        </div>
        {searchBrand ? (
          <SearchBrand
            setSearchBrand={setSearchBrand}
            searchBrand={searchBrand}
            isQuickSearchUsed={isQuickSearchUsed}
            setIsQuickSearchUsed={setIsQuickSearchUsed}
          />
        ) : (
          <QuickCatalog groups={fastSearchData} onSelect={handleQuickSearch} />
        )}
      </div>
    </div>
  )
}

export default Search
